// SPDX-FileCopyrightText: 2026 Sequent Tech Inc <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
import { EMessageAttemptState } from "@/types/messaging";
/** The event's Logs tab, selected by a link's `tabId`. */
export var LOGS_TAB_ID = "logs";
/** Log filters of the messages a SendCommunications entry records. */
export var LOG_FILTER_CHANNEL = "channel";
export var LOG_FILTER_OUTCOME = "outcome";
var SEND_COMMUNICATIONS = "SendCommunications";
/** The Logs channel filter value of messages with no channel (voters with no contact). */
export var LOG_CHANNEL_NONE = "none";
/**
 * The search of the event page that opens Logs with the failed messages of
 * `channel`. The list reads `filter` and `displayedFilters` from the location,
 * so the filters show and can be cleared like any other.
 */
export var logsFilterSearch = function (
/** `null` for the messages of voters with no contact channel. */
channel, outcome) {
    var _a, _b;
    if (outcome === void 0) { outcome = EMessageAttemptState.FAILED; }
    return "?".concat(new URLSearchParams({
        tabId: LOGS_TAB_ID,
        filter: JSON.stringify((_a = {
                statement_kind: SEND_COMMUNICATIONS
            },
            _a[LOG_FILTER_CHANNEL] = channel !== null && channel !== void 0 ? channel : LOG_CHANNEL_NONE,
            _a[LOG_FILTER_OUTCOME] = outcome,
            _a)),
        displayedFilters: JSON.stringify((_b = {
                statement_kind: true
            },
            _b[LOG_FILTER_CHANNEL] = true,
            _b[LOG_FILTER_OUTCOME] = true,
            _b)),
    }).toString());
};
